import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { YoutubeIntegrationComponent } from './youtube-integration/youtube-integration.component';

@Component({
  selector: 'app-integrations',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, YoutubeIntegrationComponent],
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.scss'
})
export class IntegrationsComponent {
  selectedIntegration = signal<string>('youtube');

  integrationTypes = [
    { id: 'youtube', name: 'YouTube', icon: 'pi pi-youtube' }
  ];
}
